export var Products = {
  JIRA: 'jira',
  CONFLUENCE: 'confluence'
};